import { render, staticRenderFns } from "./NewExpedient.vue?vue&type=template&id=59c7ff09&scoped=true&"
import script from "./NewExpedient.vue?vue&type=script&lang=js&"
export * from "./NewExpedient.vue?vue&type=script&lang=js&"
import style0 from "./NewExpedient.vue?vue&type=style&index=0&id=59c7ff09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c7ff09",
  null
  
)

export default component.exports